export default {"src":"/_next/static/media/ai-conversation.mono.5b306c6c.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};